import React from 'react';
import { rem } from 'polished';
import { styled } from 'styles';
import {
  PersonalisedTodayContent_homeAssembly_featuredHeroCourses as FeaturedHeroCourse,
  PersonalisedTodayContent_dailyBoostShort as DailyBoost,
} from 'Home/PersonalisedToday/__generated__/PersonalisedTodayContent';
import FeaturedDailyBoost from './FeaturedDailyBoost';
import FeaturedHero from './FeaturedHero';

export const FeaturedContentWrapper = styled.div`
  margin-top: ${rem(40)};
`;

type FeaturedContentProps = {
  assetToken: string | null | undefined;
  featuredHeroCourses: FeaturedHeroCourse[];
  dailyBoost?: DailyBoost | null;
};

const FeaturedContent = ({
  assetToken,
  featuredHeroCourses,
  dailyBoost,
}: FeaturedContentProps) =>
  !featuredHeroCourses.length ? (
    <FeaturedDailyBoost assetToken={assetToken} dailyBoost={dailyBoost} />
  ) : (
    <FeaturedHero assetToken={assetToken} course={featuredHeroCourses[0]} />
  );

export default FeaturedContent;
